import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL } from "./CtaButton";
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const el = document.getElementById("first-cta");
      if (!el) return;
      setVisible(el.getBoundingClientRect().bottom < 0);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, {
      passive: true
    });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);
  return <AnimatePresence data-id="element-38" data-mp="bq9fgqvr9a0r">
      {visible && <motion.div initial={{
      y: 120,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 120,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3 pt-2 md:pb-5" data-id="element-39" data-mp="195wszeeohtah">
          <a href={CHECKOUT_URL} className="animate-cta-shake mx-auto flex w-full max-w-md items-center justify-center gap-2 rounded-2xl bg-brand-cta px-5 py-4 text-[15px] font-extrabold uppercase tracking-wide text-white shadow-[0_5px_0_0_#24481a,0_16px_30px_-8px_rgba(30,50,25,0.55)] hover:bg-brand-ctaDark focus:outline-none focus-visible:ring-4 focus-visible:ring-brand-sage/50 md:text-base" data-id="element-40" data-mp="2f3sp2p5l82hm">
            <span className="whitespace-nowrap" data-id="element-41" data-mp="1welzci6dmamb">Get The Aroma Lab™ — $27</span>
            <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-42" data-mp="1ieb7bbtbypzk" />
          </a>
        </motion.div>}
    </AnimatePresence>;
}